import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import styles from './SharedRespLinksBlock.scss';
import classnames from 'classnames';

export const SharedRespLinksBlock = ({
    links,
    anchorTextPrefix,
    title,
    dataTn,
    noBottomMargin,
}) => {
    const linksClassName = classnames(styles.links, 'rowFlex', {
        [styles.noBottomMargin]: noBottomMargin,
    });

    return (
        <HeadingLevel>
            {Heading => (
                <div data-tn={dataTn}>
                    <BarHeader title={title} htmlElementType={Heading} />
                    <div className={linksClassName}>
                        {links.map(({ anchorText, url }) => (
                            <Link
                                key={url}
                                href={url}
                                className={classnames(styles.link, 'colXs12', 'colMd4')}
                            >
                                {anchorTextPrefix
                                    ? `${anchorTextPrefix} ${anchorText}`
                                    : anchorText}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </HeadingLevel>
    );
};

SharedRespLinksBlock.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            anchorText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
    anchorTextPrefix: PropTypes.string,
    title: PropTypes.string.isRequired,
    dataTn: PropTypes.string.isRequired,
    noBottomMargin: PropTypes.bool,
};
